/**
 * Scrollbars that only show while you scroll.
 *
 * One passive listener for the whole document, in the capture phase so it
 * hears every scroller - scroll events do not bubble. Whatever is scrolling
 * gets data-scrolling, which the stylesheet turns into a visible thumb, and
 * loses it a moment after it stops.
 */

const timers = new WeakMap<Element, number>();
const LINGER_MS = 900;

function onScroll(e: Event): void {
  const el = e.target === document ? document.documentElement : e.target;
  if (!(el instanceof Element)) return;
  if (!el.hasAttribute('data-scrolling')) el.setAttribute('data-scrolling', '');
  const old = timers.get(el);
  if (old) window.clearTimeout(old);
  timers.set(el, window.setTimeout(() => {
    timers.delete(el);
    el.removeAttribute('data-scrolling');
  }, LINGER_MS));
}

/** Starts listening. Called once, from the shell. */
export function watchScrollbars(): () => void {
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  return () => document.removeEventListener('scroll', onScroll, { capture: true });
}
